/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementPropertyDto
 */
export interface TrackItMeasurementPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementPropertyDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementPropertyDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementPropertyDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementPropertyDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementPropertyDto
     */
    $type?: TrackItMeasurementPropertyDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementPropertyDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementPropertyDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementPropertyDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementPropertyDtoTypeEnum = typeof TrackItMeasurementPropertyDtoTypeEnum[keyof typeof TrackItMeasurementPropertyDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementPropertyDto interface.
 */
export function instanceOfTrackItMeasurementPropertyDto(value?: unknown): value is TrackItMeasurementPropertyDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementPropertyDtoTypeEnum)[0];
}

export function TrackItMeasurementPropertyDtoFromJSON(json: any): TrackItMeasurementPropertyDto {
    return TrackItMeasurementPropertyDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementPropertyDtoToJSON(value?: TrackItMeasurementPropertyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

